define(
({
  "load_error": "Chyba načítání",
  "description": "Žádost nebyla správně dokončena. Měli byste se ujistit, že je vaše objednávka uložena, a poté tuto stránku aktualizovat."
})
);
